class OffPanel extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    document.body.addEventListener(
      'keyup',
      (evt) => evt.code.toUpperCase() === 'ESCAPE' && this.isOpen && this.close()
    );

    if (this.querySelector('.offpanel__close')) {
      this.querySelectorAll('.offpanel__close').forEach((el) => {
        el.addEventListener('click', this.close);
      });
    }
    if (this.querySelector('.offpanel__backdrop')) {
      this.querySelector('.offpanel__backdrop').addEventListener('click', this.close);
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.classList.add('open');

    let scrollBarWidth = window.innerWidth - document.documentElement.offsetWidth;

    document.body.style.paddingRight = scrollBarWidth + 'px';
    if (document.body.querySelector('.site-header').classList.contains('header-sticky--smart')) {
      document.body.querySelector('.header-sticky--smart').style.paddingRight = scrollBarWidth + 'px';
    }

    const openEvent = new CustomEvent('offpanel_opened', { detail: { panel: this } });
    document.body.dispatchEvent(openEvent);
    document.body.classList.add('offpanel-opened');
  }

  close() {
    this.isOpen = false;
    this.classList.add('hidding');
    this.classList.remove('open');

    setTimeout(() => {
      this.classList.remove('hidding');

      document.body.style.removeProperty('padding-right');
      if (document.body.querySelector('.site-header').classList.contains('header-sticky--smart')) {
        document.body.querySelector('.header-sticky--smart').style.removeProperty('padding-right');
      }

      const closeEvent = new CustomEvent('offpanel_closed', { detail: { panel: this } });
      document.body.dispatchEvent(closeEvent);
      document.body.classList.remove('offpanel-opened');
    }, 500);
  }
}

customElements.define('off-panel', OffPanel);

class OffPanelOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('[data-panel]');

    if (!button) {
      return;
    }

    this.panel = document.getElementById(button.dataset.panel);

    button.addEventListener('click', this.togglePanel.bind(this));
  }

  togglePanel(e) {
    e.preventDefault();

    if (this.panel) {
      this.panel.toggle();
    }
  }
}

customElements.define('off-panel-opener', OffPanelOpener);
